module.exports = __webpack_public_path__ + "static/media/List-App-Mobile-12.abfcbf5e.png";